export class ActivityImage {
    constructor() {
        if ($('.activity-block--pic a[data-btn-to-login="true"]').length > 0) {
            this.bindClickEvent();
        }
    }

    bindClickEvent() {
        $('.activity-block--pic a[data-btn-to-login="true"]').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (pageInfo.customerInfo?.id) {
                pushSuccessMessage($(this).data('loggedInMsg') || 'You are already logged in.');
            } else {
                const hash = $(this).parent().parent().parent().attr('anchor');
                window.jackeryLoginApp && window.jackeryLoginApp.modalLogin({
                    return_url: window.location.href + "?hash=" + hash,
                    "register_act": "Account-Register"
                });
            }
        });
    }
}